// extracted by mini-css-extract-plugin
export default {"quickGuidesCard__topicCard":"QuickGuidesCard_quickGuidesCard__topicCard__YPkNZ","quickGuidesCard__cardImageContainer":"QuickGuidesCard_quickGuidesCard__cardImageContainer__u-KgX"};